import {initialExperimentalFeatures} from './reducers';

const experimentalFeaturesKey = 'alva:experimental_features';

export const getExperimentalFeaturesState = () => {
    if (!window.localStorage || !window.localStorage.getItem(experimentalFeaturesKey)) {
        return initialExperimentalFeatures;
    }

    // Parse data from local storage
    let savedState;

    try {
        savedState = JSON.parse(localStorage.getItem(experimentalFeaturesKey));
    }
    catch (e) {
        return initialExperimentalFeatures;
    }

    // Make sure that the returned object have the same format as 'initialUi'
    // This returns a new object where initialUi is overridden with settings in saved state
    return Object.assign({}, initialExperimentalFeatures, savedState);
};

export const saveExperimentalFeaturesState = (experimentalFeatures) => {
    if (!window.localStorage) {
        return;
    }
    window.localStorage.setItem(experimentalFeaturesKey, JSON.stringify(experimentalFeatures));
};
